<template>
  <div class="waste-type-detail">
    <slot v-if="!activeWasteType && !activeContent"></slot>
    <div v-if="activeWasteType && activeWasteStream && !isWasteStream">
      <h3 class="u-txt-c">{{ activeSynonym }} bij: {{ activeWasteStream.name }}</h3>
    </div>
    <div v-if="activeContent">
      <div class="waste-type-detail__intro u-p">
        <p v-if="activeSynonym">
          Het afval <b>{{ activeSynonym }}</b> hoort bij {{ activeContent.name }} en valt onder <b>{{ activeWasteStream.name }}</b>
        </p>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="activeContent.intro"></div>
        <div class="u-txt-r">
          <a v-if="activeContent.recycleLink" :href="activeContent.recycleLink" class="btn-arrowed">
            Recycleplein <i class="fa fa-chevron-right u-float-right" />
          </a>
          <a v-if="activeContent.containersLink" :href="activeContent.containersLink" class="btn-arrowed">
            Locaties containers<i class="fa fa-chevron-right u-float-right" />
          </a>
          <a v-if="activeContent.bestTasLink" :href="activeContent.bestTasLink" class="btn-arrowed">
            BEST-tas <i class="fa fa-chevron-right u-float-right" />
          </a>
          <a v-if="activeContent.KCALink" :href="activeContent.KCALink" class="btn-arrowed">
            Chemokar <i class="fa fa-chevron-right u-float-right" />
          </a>
        </div>
      </div>
      <ElCollapse v-if="showRules || showTips || showAllowedItems || showDisallowedItems" accordion>
        <ElCollapseItem v-if="showRules">
          <template slot="title">
            <span class="waste-type-detail__heading">Spelregels</span>
          </template>
          <div class="u-p u-pl-10 u-pb-0">
            <ul>
              <li v-for="(rule, index) in activeContent.rules" :key="index">
                <span>{{ rule.description }}</span>
              </li>
            </ul>
          </div>
        </ElCollapseItem>
        <ElCollapseItem v-if="showTips">
          <template slot="title">
            <span class="waste-type-detail__heading">Tips</span>
          </template>
          <div v-for="(tip, index) in activeContent.tips" :key="index" class="u-pl-10">
            <i class="fas fa-info-circle u-mr-10" />{{ tip.description }}
          </div>
        </ElCollapseItem>
        <ElCollapseItem v-if="showAllowedItems">
          <template slot="title">
            <span class="waste-type-detail__heading">Wat hoort bij {{ activeContent.name }}</span>
          </template>
          <div v-for="(allowedItem, index) in allowedItems" :key="index" class="u-pl-10">
            <div v-if="allowedItem.length > 0"><i class="fas fa-check-circle u-color-success u-mr-10" />{{ allowedItem }}</div>
          </div>
        </ElCollapseItem>
        <ElCollapseItem v-if="showDisallowedItems">
          <template slot="title">
            <span class="waste-type-detail__heading">Wat hoort er niet bij {{ activeContent.name }}</span>
          </template>
          <div v-for="(disallowedItem, index) in disallowedItems" :key="index" class="u-pl-10">
            <div v-if="disallowedItem.length > 0"><i class="fas fa-times-circle u-color-danger u-mr-10" />{{ disallowedItem }}</div>
          </div>
        </ElCollapseItem>
      </ElCollapse>
    </div>
  </div>
</template>

<script>
import store from '../Store/store'
import { Collapse, CollapseItem } from 'element-ui'

export default {
  name: 'WasteTypeDetail',

  components: {
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem
  },
  data() {
    return {}
  },
  computed: {
    activeWasteType() {
      return store.getters['waste/getActiveWasteType']
    },
    isWasteStream() {
      return store.getters['waste/isWasteStream']
    },
    wasteStreams() {
      return store.getters['waste/getWasteStreams']
    },
    hasActiveWasteStream() {
      return typeof this.activeWasteStream === 'object'
    },
    activeWasteStream() {
      return store.getters['waste/getActiveWasteStream']
    },
    hasActiveWasteType() {
      return this.activeWasteType !== null
    },
    activeContent() {
      if (this.activeWasteType) {
        return this.activeWasteType
      } else {
        return store.getters['waste/getActiveWasteStream']
      }
    },
    disallowedItems() {
      return this.activeContent.disallowed
    },
    allowedItems() {
      return this.activeContent.allowed
    },
    activeSynonym() {
      return store.getters['waste/getActiveSynonym']
    },
    showRules() {
      return this.activeContent.rules.length > 0
    },
    showTips() {
      return this.activeContent.tips.length > 0
    },
    showAllowedItems() {
      return this.allowedItems
    },
    showDisallowedItems() {
      return this.disallowedItems
    }
  }
}
</script>
